import { useState } from 'react';
import { Input } from './input';
import { Eye, EyeOff } from 'lucide-react';

const PasswordInput = ({ 
  id, 
  value, 
  onChange, 
  placeholder = '••••••••',
  className = '',
  required = false,
  minLength,
  'data-testid': dataTestId,
  ...props 
}) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className="relative">
      <Input
        id={id}
        type={showPassword ? 'text' : 'password'}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        className={`pr-10 ${className}`}
        required={required}
        minLength={minLength}
        data-testid={dataTestId}
        {...props}
      />
      <button
        type="button"
        onClick={() => setShowPassword(!showPassword)}
        className="absolute right-3 top-1/2 -translate-y-1/2 text-neutral-500 hover:text-neutral-300 focus:outline-none"
        data-testid={dataTestId ? `${dataTestId}-toggle` : 'password-toggle'}
        aria-label={showPassword ? 'Hide password' : 'Show password'}
      >
        {showPassword ? (
          <EyeOff className="w-4 h-4" />
        ) : (
          <Eye className="w-4 h-4" />
        )}
      </button>
    </div>
  );
};

export { PasswordInput };
